<div
  class="pickup-details-dialog-header"
>
  <h1>
    Pickup Details 
    <span style="color: #ff6c36; font-weight: 600"
      > {{shipmentData?.shipment_number}}</span
    >
  </h1>
  <button
    (click)="close()"
    style="
      position: absolute;
      top: -18px;
      right: -18px;
      background-color: #fff;
      border: 1px solid #f4f4f4;
      border-radius: 100%;
      min-width: 36px;
      min-height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
    "
  >
    <i class="fas fa-times" style="font-size: 24px; color: red"></i>
  </button>
</div>

<div mat-dialog-content>
  <div class="pickup-details-wrapper"> 
    <div class="pickup-details-date">
      <strong>Pickup Date</strong>

      <p>
        {{pickupDisplayDateTime.date}}
      </p>
    </div>
    <div class="pickup-details-hours">
      <strong>Pickup Hours</strong>
      <p>{{pickupDisplayDateTime.hours}} - {{pickupDisplayDateTimeFEnd.hours}}</p>
    </div>
    <div class="pickup-details-address">
      <strong>Pickup Address</strong>
      <p>
        {{pickupAddress.line1}} {{pickupAddress.line2}} <br> 
        {{pickupAddress.city_name}} / {{pickupAddress.state}} <br>
        {{pickupAddress.post_code}} <br>
        {{pickupAddress.country_code}}
      </p>
    </div>
  </div>
</div>
